import TechAssistanceView from '../../pages/TechAssistanceView';

// Nome simples (PT): Página de Assistências
export default function PaginaAssistencias(props) {
  return <TechAssistanceView {...props} />;
}






